import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Form, Input, Select, InputNumber } from "antd";
import GalkButton from "../../common/component/button";
import "./style.css";
import { getSkills } from "../../../actions/organisationDataActions";

const { Option } = Select;
const { TextArea } = Input;

const JobFormItems = (props) => {
	const { t } = useTranslation();

	const {
		skillSets,
		getSkills,
		isActionProgress,
		action,
		cancelActionHandler,
	} = props;

	if (skillSets.length === 0) {
		getSkills();
	}

	return (
		<>
			<Form.Item
				label={t("createProject_title")}
				name="title"
				rules={[
					{ required: true, message: t("createProject_title_required_hint") },
				]}
			>
				<Input placeholder={t("createProject_title_placeholder")} />
			</Form.Item>
			<Form.Item
				label={t("createProject_address")}
				name="location"
				rules={[
					{ required: true, message: t("createProject_address_required_hint") },
				]}
			>
				<Input placeholder={t("createProject_address_placeholder")} />
			</Form.Item>
			<Form.Item
				name="requiredEngineerCount"
				label={t("createProject_requiredIntern")}
				rules={[
					{
						type: "number",
						min: 1,
						max: 20,
						message: "Required Intern range should be 1 to 20 ",
					},
					{
						required: true,
						message: t("createProject_requiredIntern_required_hint"),
					},
				]}
			>
				<InputNumber
					placeholder={t("createProject_requiredIntern_placeholder")}
				/>
			</Form.Item>
			<div className="project-form-item-salary-cont">
				<div className="project-form-item-salary-heading">
					{t("createProject_annualSalary_title")}{" "}
					<span style={{ color: "red" }}>
						{`${t("createProject_annualSalary_title_helpText")}`}
					</span>
				</div>
				<div className="project-form-item-salary-input">
					<Form.Item
						name="salaryFrom"
						label={""}
						rules={[
							{
								required: true,
								message: t("createProject_annualSalary_requiredHint"),
							},
						]}
					>
						{/* <Input type="number" min={1} placeholder={"800000"} /> */}
						<InputNumber
							placeholder={t("createProject_annualSalary_start_placeHolder")}
						/>
					</Form.Item>
					<div>
						<h4>{t("createProject_annualSalary_currency")} ~</h4>
					</div>
					<Form.Item
						name="salaryTo"
						label={""}
						rules={[
							{
								required: true,
								message: t("createProject_annualSalary_requiredHint"),
							},
						]}
					>
						<InputNumber
							placeholder={t("createProject_annualSalary_end_placeHolder")}
						/>
					</Form.Item>
					<div>
						<h4>{t("createProject_annualSalary_currency")} </h4>
					</div>
				</div>
			</div>
			<Form.Item
				name="mustHaveSkills"
				label={t("createProject_mustHaveSkills_title")}
				rules={[
					{
						type: "array",
						required: true,
						message: t("createProject_mustHaveSkills_required_hint"),
					},
				]}
			>
				<Select
					mode="tags"
					placeholder={t("createProject_mustHaveSkills_placeholder")}
					disabled={isActionProgress}
				>
					{skillSets &&
						skillSets.map((skill, i) => (
							<Option key={`skill:${i}`} value={skill}>
								{skill}
							</Option>
						))}
				</Select>
			</Form.Item>
			<Form.Item
				name="oneOfTheFollowingSkills"
				label={t("createProject_oneOfTheFollowingSkills_title")}
				rules={[
					{
						type: "array",
					},
				]}
			>
				<Select
					mode="tags"
					placeholder={t("createProject_oneOfTheFollowingSkills_placeholder")}
					disabled={isActionProgress}
				>
					{skillSets &&
						skillSets.map((skill, i) => (
							<Option key={`skill:${i}`} value={skill}>
								{skill}
							</Option>
						))}
				</Select>
			</Form.Item>
			<Form.Item
				name="niceToHaveSkills"
				label={t("createProject_niceToHaveSkills_title")}
				rules={[
					{
						type: "array",
					},
				]}
			>
				<Select
					mode="tags"
					placeholder={t("createProject_niceToHaveSkills_placeholder")}
					disabled={isActionProgress}
				>
					{skillSets &&
						skillSets.map((skill, i) => (
							<Option key={`optionalSKill:${i}`} value={skill}>
								{skill}
							</Option>
						))}
				</Select>
			</Form.Item>
			<Form.Item
				label={t("createProject_details_title")}
				name="details"
				rules={[{ required: true, message: t("job_description_required") }]}
			>
				<TextArea
					autoSize={{ minRows: 3, maxRows: 8 }}
					placeholder={t("createProject_details_placeholder")}
				/>
			</Form.Item>
			<Form.Item
				label={t("createProject_softSkillSought_title")}
				name="softSkills"
				rules={[
					{
						required: true,
						message: t("createProject_softSkillSought_required_hint"),
					},
				]}
			>
				<TextArea
					autoSize={{ minRows: 1, maxRows: 3 }}
					placeholder={t("createProject_softSkillSought_placeholder")}
				/>
			</Form.Item>
			<Form.Item
				label={t("createProject_developmentEnv_title")}
				name="developmentEnvironment"
			>
				<TextArea
					autoSize={{ minRows: 2, maxRows: 5 }}
					placeholder={t("createProject_developmentEnv_placeholder")}
				/>
			</Form.Item>
			<Form.Item
				label={t("createProject_stagingEnv_title")}
				name="stagingEnvironment"
			>
				<TextArea
					autoSize={{ minRows: 2, maxRows: 5 }}
					placeholder={t("createProject_stagingEnv_placeholder")}
				/>
			</Form.Item>
			<Form.Item
				label={t("createProject_operationalEnv_title")}
				name="operationalEnvironment"
			>
				<TextArea
					autoSize={{ minRows: 2, maxRows: 5 }}
					placeholder={t("createProject_operationalEnv_placeholder")}
				/>
			</Form.Item>
			<Form.Item
				label={t("createProject_otherComment_title")}
				name="otherComment"
			>
				<TextArea
					autoSize={{ minRows: 2, maxRows: 5 }}
					placeholder={t("createProject_otherComment_placeholder")}
				/>
			</Form.Item>
			<div className="project-form-controls-cont">
				<GalkButton
					type="secondary"
					onClick={cancelActionHandler}
					width={90}
					className="project-form-control-btn"
				>
					{t("createProject_modalAction_cancel")}
				</GalkButton>
				<GalkButton
					type="primary"
					htmlType="submit"
					loading={isActionProgress}
					width={90}
					className="project-form-control-btn"
				>
					{action === "create"
						? t("createProject_modalAction_submit")
						: t("editProject_modalAction_submit")}
				</GalkButton>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	skillSets: state.organisationData.skills,
});

export default connect(mapStateToProps, { getSkills })(JobFormItems);
